import type { IconSvgObject } from './types';

const Undo03Icon: IconSvgObject = [
  ["path", { d: "M3 8H15C18.3137 8 21 10.6863 21 14C21 17.3137 18.3137 20 15 20H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 12L3 8L7 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Undo03Icon;
